import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  min-width: 60vw;
  th,
  td {
    padding: 0.7rem;
    text-align: left;
  }
  th {
    font-weight: bold;
    font-size: 0.7rem;
    color: var(--pd-dark-text-color);
  }
  td {
    color: var(--pd-dark-text-color);
    font-weight: bold;
    font-size: 0.9rem;
  }
  tr:nth-child(even) {
    background: var(--pd-grey-bg-color);
  }
`;
